import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import CustomSelect from '../../../ui/CustomSelect';

export default function MappingModal({
  open,
  data,
  positions,
  jobGrades,
  saving,
  onClose,
  onSave,
}) {
  const [form, setForm] = useState(data || {});

  useEffect(() => {
    setForm(data || {});
  }, [data]);

  if (!open) return null;

  const handleSubmit = e => {
    e.preventDefault();
    onSave(form);
  };

  const positionOptions = [
    { value: '', label: 'Pilih jabatan' },
    ...positions.filter(p => p.status === 'active').map(p => ({ value: p.id, label: p.name })),
  ];

  const gradeOptions = [
    { value: '', label: 'Pilih golongan' },
    ...jobGrades
      .filter(g => g.is_active)
      .map(g => ({ value: g.id, label: `${g.grade_code} - ${g.grade_name}` })),
  ];

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-hidden animate-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">Tambah Mapping Jabatan - Golongan</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-4 max-h-[60vh] overflow-y-auto">
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Jabatan <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                value={form?.position_id || ''}
                onChange={val => setForm({ ...form, position_id: val })}
                options={positionOptions}
                placeholder="Pilih jabatan"
                width="w-full"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Golongan <span className="text-red-500">*</span>
              </label>
              <CustomSelect
                value={form?.grade_id || ''}
                onChange={val => setForm({ ...form, grade_id: val })}
                options={gradeOptions}
                placeholder="Pilih golongan"
                width="w-full"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                Tanggal Berlaku <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={form?.effective_date || ''}
                onChange={e => setForm({ ...form, effective_date: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                required
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Tanggal Berakhir</label>
              <input
                type="date"
                value={form?.end_date || ''}
                onChange={e => setForm({ ...form, end_date: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 font-medium"
          >
            {saving ? 'Menyimpan...' : 'Simpan'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
